import React from 'react';
import { Container, FlexibleCol, Row } from '@yme/atoms/grid';
import { getColumnNumberForDesktop } from '@yme/components/HomePage/components/helpers';
import { ForOwnersCard } from '@yme/molecules/cards';
import { buildKey, buildStateParam } from '@yme/utils/common';
import { SPECIAL_OFFERS_MAX_CARD, SPECIAL_OFFERS_TABLET_TEST_ID } from './constants';
import { calcMarginBottom, getItemForTabletView } from './helpers';
export function TabletCards({ cards, isRightToLeft }) {
    const changedCards = cards.map((card) => getItemForTabletView(card));
    const cardsElements = changedCards.map((card, index) => (React.createElement(FlexibleCol, { md: getColumnNumberForDesktop(cards.length, SPECIAL_OFFERS_MAX_CARD), key: buildKey(buildStateParam(), card.title) },
        React.createElement(ForOwnersCard, { marginBottom: calcMarginBottom(cards.length, index), isRightToLeft: isRightToLeft, cardProps: card }))));
    return (React.createElement(Container, { dataTestId: SPECIAL_OFFERS_TABLET_TEST_ID, isRightToLeft: isRightToLeft },
        React.createElement(Row, null, cardsElements)));
}
